export function defineWebComponent(
  elementName: string,
  componentClass: any
): void {
  if (!customElements.get(elementName)) { // Check if the custom element is already defined
    customElements.define(elementName, componentClass);
  }
}